import { useDisclosure, useToast } from '@chakra-ui/react'
import { useSelector } from 'react-redux'

import { useEffect, useState } from 'react'

import axios from 'axios'
import sockets from '../../../../../socket/socket'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button

} from '@chakra-ui/react'


export default function ChangeDateChild({ item, isChild, currentDate, allitemForStatus, index, update }) {

    const toast = useToast()
    const socket = sockets
    let getmyinfo = useSelector(compID => compID.getMayInfoReducer)
    const myinfos = useSelector(data => data.getMyImageReducer);
    const [endDateConfirm, setDndDateConfirm] = useState();
    const [currentDates, setcurrentDate] = useState("")
    let getCompanyID = useSelector(compID => compID.checkedSessionReducer)
    const getDarkModoe = useSelector(darkModes => darkModes);
    const { isOpen, onOpen, onClose } = useDisclosure()


    useEffect(() => {
        setcurrentDate(item?.alltask[0]?.child[index].endDate)
        setDndDateConfirm(item.alltask[0].child[index].endDate)
    }, [allitemForStatus,item])

    const handleUpdateStatus = (e) => {
        allitemForStatus.alltask[0].child[index].endDate = endDateConfirm
        axios.post('/updateMyTaskForStatusAndPriritet/api', {
            allitemForStatus
        })
            .then(function (response) {

                update()
                onClose()
                toast({
                    position: "top",
                    title: response.data.message,
                    description: response.data.message,
                    status: 'success',
                    duration: 9000,
                    isClosable: true,
                })

            })
            .catch(function (error) {
                console.log(error);

            });

    }

    const handleDate = () => {
        axios.post('/notifyConfirm', {
            eidtTaskID: allitemForStatus._id,
            isChild: true,
            adminIDTask: allitemForStatus.creatorTasks.toString(),
            typenotify: "date",
            indexTask: index,
            senderName: getmyinfo.myinfo.name,
            senderTel: getmyinfo.myinfo.tel,
            senderEmail: getmyinfo.myinfo.email,
            text: "",
            messageConfirm: endDateConfirm,
            taskName: allitemForStatus.alltask[0].child[index].msg,
            oldDate: allitemForStatus.alltask[0].child[index].endDate,
            myAvatar: myinfos.users.myavatar

        })
            .then(function (response) {

                socket.emit('getNotifyEmit');
                onClose()
                toast({
                    position: "top",
                    title: 'Отправлено на подтверждение постановщику задачи',
                    description: "Отправлено на подтверждение постановщику задачи",
                    status: 'success',
                    duration: 9000,
                    isClosable: true,
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }


    function dateisCurrent(endDate) {
          
            
        let currentDate = new Date().toISOString();
        
        if (currentDate >= new Date(item?.alltask[0]?.child[index].endDate).toISOString() && item?.alltask[0]?.child[index].status !== "Выполнена" && item?.alltask[0]?.child[index].status !== "Закрыта") {
            return true;
        } else {
            return false;
        }
    }

    function convertDate(date) {
        const newDate = new Date(date);
        const getDay = String(newDate.getDate()).padStart(2, '0');
        const getMonth = String(newDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const getYear = newDate.getFullYear();
        const getHours = String(newDate.getHours()).padStart(2, '0');
        const getMinutes = String(newDate.getMinutes()).padStart(2, '0');
        const formatted = `${getDay}.${getMonth}.${getYear} ${getHours}:${getMinutes}`;
        return formatted
    }
    const convertEndDate = (dateString) => {
        // Преобразуем строку в объект Date
        const date = new Date(dateString);

        // Получаем компоненты даты и времени
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        // Собираем строку в нужном формате
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    // Пример использования

    const formattedEndDate = convertEndDate(endDateConfirm);

    const convertStartDate = (dateString) => {
        const date = new Date(dateString);

        // Add 13 days
        date.setDate(date.getDate() + 13);

        // Add 10 minutes
        date.setMinutes(date.getMinutes() + 10);

        // Format the date
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    if (getmyinfo.myinfo._id === allitemForStatus.creatorTasks) {
        return (
            <div key={index + getmyinfo.myinfo._id} className={getDarkModoe.ToggleDarkModeReducer.chekced ? "DateEditForTableDark" : "DateEditForTable"}>

                {/* <button onClick={handleUpdateStatus}>Подтвердить</button> */}

                <div>
                    <input type="text" onClick={onOpen} value={convertDate(currentDates)} style={dateisCurrent(allitemForStatus.alltask[0].endDate) ? { color: "red" } : { border: "#707A99" }} />
                    <div onClick={onOpen}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9 5H15V4.50468C15 4.21404 15.226 4 15.5047 4H16.4953C16.786 4 17 4.22595 17 4.50468V5H18.7568C19.3028 5 19.75 5.44725 19.75 5.99896V7.00104C19.75 7.55734 19.3053 8 18.7568 8H5.24317C4.69717 8 4.25 7.55275 4.25 7.00104V5.99896C4.25 5.44266 4.69466 5 5.24317 5H7V4.50468C7 4.21404 7.22596 4 7.50468 4H8.49532C8.78596 4 9 4.22595 9 4.50468V5ZM5.50468 9H6.49532C6.78596 9 7 9.22596 7 9.50468V10.4953C7 10.786 6.77404 11 6.49532 11H5.50468C5.21404 11 5 10.774 5 10.4953V9.50468C5 9.21404 5.22595 9 5.50468 9ZM8.50468 9H9.49532C9.78596 9 10 9.22596 10 9.50468V10.4953C10 10.786 9.77404 11 9.49532 11H8.50468C8.21404 11 8 10.774 8 10.4953V9.50468C8 9.21404 8.22596 9 8.50468 9ZM11.5047 9H12.4953C12.786 9 13 9.22596 13 9.50468V10.4953C13 10.786 12.774 11 12.4953 11H11.5047C11.214 11 11 10.774 11 10.4953V9.50468C11 9.21404 11.226 9 11.5047 9ZM5.50468 12H6.49532C6.78596 12 7 12.226 7 12.5047V13.4953C7 13.786 6.77404 14 6.49532 14H5.50468C5.21404 14 5 13.774 5 13.4953V12.5047C5 12.214 5.22595 12 5.50468 12ZM8.50468 12H9.49532C9.78596 12 10 12.226 10 12.5047V13.4953C10 13.786 9.77404 14 9.49532 14H8.50468C8.21404 14 8 13.774 8 13.4953V12.5047C8 12.214 8.22596 12 8.50468 12ZM11.5047 12H12.4953C12.786 12 13 12.226 13 12.5047V13.4953C13 13.786 12.774 14 12.4953 14H11.5047C11.214 14 11 13.774 11 13.4953V12.5047C11 12.214 11.226 12 11.5047 12ZM5.50468 15H6.49532C6.78596 15 7 15.226 7 15.5047V16.4953C7 16.786 6.77404 17 6.49532 17H5.50468C5.21404 17 5 16.774 5 16.4953V15.5047C5 15.214 5.22595 15 5.50468 15ZM8.50468 15H9.49532C9.78596 15 10 15.226 10 15.5047V16.4953C10 16.786 9.77404 17 9.49532 17H8.50468C8.21404 17 8 16.774 8 16.4953V15.5047C8 15.214 8.22596 15 8.50468 15ZM11.5047 15H12.4953C12.786 15 13 15.226 13 15.5047V16.4953C13 16.786 12.774 17 12.4953 17H11.5047C11.214 17 11 16.774 11 16.4953V15.5047C11 15.214 11.226 15 11.5047 15ZM14.5047 9H15.4953C15.786 9 16 9.22596 16 9.50468V10.4953C16 10.786 15.774 11 15.4953 11H14.5047C14.214 11 14 10.774 14 10.4953V9.50468C14 9.21404 14.226 9 14.5047 9ZM14.5047 12H15.4953C15.786 12 16 12.226 16 12.5047V13.4953C16 13.786 15.774 14 15.4953 14H14.5047C14.214 14 14 13.774 14 13.4953V12.5047C14 12.214 14.226 12 14.5047 12ZM14.5047 15H15.4953C15.786 15 16 15.226 16 15.5047V16.4953C16 16.786 15.774 17 15.4953 17H14.5047C14.214 17 14 16.774 14 16.4953V15.5047C14 15.214 14.226 15 14.5047 15ZM17.5047 15H18.4953C18.786 15 19 15.226 19 15.5047V16.4953C19 16.786 18.774 17 18.4953 17H17.5047C17.214 17 17 16.774 17 16.4953V15.5047C17 15.214 17.226 15 17.5047 15ZM5.50468 18H6.49532C6.78596 18 7 18.226 7 18.5047V19.4953C7 19.786 6.77404 20 6.49532 20H5.50468C5.21404 20 5 19.774 5 19.4953V18.5047C5 18.214 5.22595 18 5.50468 18ZM8.50468 18H9.49532C9.78596 18 10 18.226 10 18.5047V19.4953C10 19.786 9.77404 20 9.49532 20H8.50468C8.21404 20 8 19.774 8 19.4953V18.5047C8 18.214 8.22596 18 8.50468 18ZM11.5047 18H12.4953C12.786 18 13 18.226 13 18.5047V19.4953C13 19.786 12.774 20 12.4953 20H11.5047C11.214 20 11 19.774 11 19.4953V18.5047C11 18.214 11.226 18 11.5047 18ZM14.5047 18H15.4953C15.786 18 16 18.226 16 18.5047V19.4953C16 19.786 15.774 20 15.4953 20H14.5047C14.214 20 14 19.774 14 19.4953V18.5047C14 18.214 14.226 18 14.5047 18ZM17.5047 18H18.4953C18.786 18 19 18.226 19 18.5047V19.4953C19 19.786 18.774 20 18.4953 20H17.5047C17.214 20 17 19.774 17 19.4953V18.5047C17 18.214 17.226 18 17.5047 18ZM17.5047 12H18.4953C18.786 12 19 12.226 19 12.5047V13.4953C19 13.786 18.774 14 18.4953 14H17.5047C17.214 14 17 13.774 17 13.4953V12.5047C17 12.214 17.226 12 17.5047 12ZM17.5047 9H18.4953C18.786 9 19 9.22596 19 9.50468V10.4953C19 10.786 18.774 11 18.4953 11H17.5047C17.214 11 17 10.774 17 10.4953V9.50468C17 9.21404 17.226 9 17.5047 9Z" fill="#353535" />
                        </svg>
                    </div>
                </div>

                <Modal isOpen={isOpen} onClose={onClose} >
                    <ModalOverlay />
                    <ModalContent className={getDarkModoe.ToggleDarkModeReducer.chekced ? "chageDateContentDark" : "chageDateContentLight"}>
                        <ModalHeader>Изменить дату</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <input type="datetime-local" value={formattedEndDate} onChange={(e) => setDndDateConfirm(e.target.value)} style={dateisCurrent(allitemForStatus.alltask[0].endDate) ? { color: "red" } : { border: "#707A99" }} />
                            {/* <input type="datetime-local" className='changeDateInput' value={convertEndDate(currentDate)} onChange={(e) => setDndDateConfirm(e.target.value)} style={dateisCurrent(allitemForStatus.alltask[0].endDate) ? { color: "red" } : { border: "#707A99" }} /> */}
                        </ModalBody>

                        <ModalFooter>
                            <Button colorScheme='blue' mr={3} onClick={() => [handleUpdateStatus(), onClose()]} >Подвердить</Button>
                            <Button variant='ghost' onClick={onClose}>
                                Закрыть
                            </Button>

                        </ModalFooter>
                    </ModalContent>
                </Modal>
            </div>
        )
    } else {
        return (
            <div key={index + getmyinfo.myinfo._id} className={getDarkModoe.ToggleDarkModeReducer.chekced ? "DateEditForTableDark" : "DateEditForTable"}>
                {/* <input type="datetime-local" defaultValue={currentDates} onChange={(e) => setDndDateConfirm(e.target.value)} style={dateisCurrent(allitemForStatus.alltask[0].endDate) ? { color: "red" } : { border: "#707A99" }} /> */}
                {/* <button onClick={handleDate}>Подтвердить</button> */}
                <div>
                    <input type="text" onClick={onOpen} value={convertDate(currentDates)} style={dateisCurrent(allitemForStatus.alltask[0].endDate) ? { color: "red" } : { border: "#707A99" }} readOnly />
                    <div onClick={onOpen}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9 5H15V4.50468C15 4.21404 15.226 4 15.5047 4H16.4953C16.786 4 17 4.22595 17 4.50468V5H18.7568C19.3028 5 19.75 5.44725 19.75 5.99896V7.00104C19.75 7.55734 19.3053 8 18.7568 8H5.24317C4.69717 8 4.25 7.55275 4.25 7.00104V5.99896C4.25 5.44266 4.69466 5 5.24317 5H7V4.50468C7 4.21404 7.22596 4 7.50468 4H8.49532C8.78596 4 9 4.22595 9 4.50468V5ZM5.50468 9H6.49532C6.78596 9 7 9.22596 7 9.50468V10.4953C7 10.786 6.77404 11 6.49532 11H5.50468C5.21404 11 5 10.774 5 10.4953V9.50468C5 9.21404 5.22595 9 5.50468 9ZM8.50468 9H9.49532C9.78596 9 10 9.22596 10 9.50468V10.4953C10 10.786 9.77404 11 9.49532 11H8.50468C8.21404 11 8 10.774 8 10.4953V9.50468C8 9.21404 8.22596 9 8.50468 9ZM11.5047 9H12.4953C12.786 9 13 9.22596 13 9.50468V10.4953C13 10.786 12.774 11 12.4953 11H11.5047C11.214 11 11 10.774 11 10.4953V9.50468C11 9.21404 11.226 9 11.5047 9ZM5.50468 12H6.49532C6.78596 12 7 12.226 7 12.5047V13.4953C7 13.786 6.77404 14 6.49532 14H5.50468C5.21404 14 5 13.774 5 13.4953V12.5047C5 12.214 5.22595 12 5.50468 12ZM8.50468 12H9.49532C9.78596 12 10 12.226 10 12.5047V13.4953C10 13.786 9.77404 14 9.49532 14H8.50468C8.21404 14 8 13.774 8 13.4953V12.5047C8 12.214 8.22596 12 8.50468 12ZM11.5047 12H12.4953C12.786 12 13 12.226 13 12.5047V13.4953C13 13.786 12.774 14 12.4953 14H11.5047C11.214 14 11 13.774 11 13.4953V12.5047C11 12.214 11.226 12 11.5047 12ZM5.50468 15H6.49532C6.78596 15 7 15.226 7 15.5047V16.4953C7 16.786 6.77404 17 6.49532 17H5.50468C5.21404 17 5 16.774 5 16.4953V15.5047C5 15.214 5.22595 15 5.50468 15ZM8.50468 15H9.49532C9.78596 15 10 15.226 10 15.5047V16.4953C10 16.786 9.77404 17 9.49532 17H8.50468C8.21404 17 8 16.774 8 16.4953V15.5047C8 15.214 8.22596 15 8.50468 15ZM11.5047 15H12.4953C12.786 15 13 15.226 13 15.5047V16.4953C13 16.786 12.774 17 12.4953 17H11.5047C11.214 17 11 16.774 11 16.4953V15.5047C11 15.214 11.226 15 11.5047 15ZM14.5047 9H15.4953C15.786 9 16 9.22596 16 9.50468V10.4953C16 10.786 15.774 11 15.4953 11H14.5047C14.214 11 14 10.774 14 10.4953V9.50468C14 9.21404 14.226 9 14.5047 9ZM14.5047 12H15.4953C15.786 12 16 12.226 16 12.5047V13.4953C16 13.786 15.774 14 15.4953 14H14.5047C14.214 14 14 13.774 14 13.4953V12.5047C14 12.214 14.226 12 14.5047 12ZM14.5047 15H15.4953C15.786 15 16 15.226 16 15.5047V16.4953C16 16.786 15.774 17 15.4953 17H14.5047C14.214 17 14 16.774 14 16.4953V15.5047C14 15.214 14.226 15 14.5047 15ZM17.5047 15H18.4953C18.786 15 19 15.226 19 15.5047V16.4953C19 16.786 18.774 17 18.4953 17H17.5047C17.214 17 17 16.774 17 16.4953V15.5047C17 15.214 17.226 15 17.5047 15ZM5.50468 18H6.49532C6.78596 18 7 18.226 7 18.5047V19.4953C7 19.786 6.77404 20 6.49532 20H5.50468C5.21404 20 5 19.774 5 19.4953V18.5047C5 18.214 5.22595 18 5.50468 18ZM8.50468 18H9.49532C9.78596 18 10 18.226 10 18.5047V19.4953C10 19.786 9.77404 20 9.49532 20H8.50468C8.21404 20 8 19.774 8 19.4953V18.5047C8 18.214 8.22596 18 8.50468 18ZM11.5047 18H12.4953C12.786 18 13 18.226 13 18.5047V19.4953C13 19.786 12.774 20 12.4953 20H11.5047C11.214 20 11 19.774 11 19.4953V18.5047C11 18.214 11.226 18 11.5047 18ZM14.5047 18H15.4953C15.786 18 16 18.226 16 18.5047V19.4953C16 19.786 15.774 20 15.4953 20H14.5047C14.214 20 14 19.774 14 19.4953V18.5047C14 18.214 14.226 18 14.5047 18ZM17.5047 18H18.4953C18.786 18 19 18.226 19 18.5047V19.4953C19 19.786 18.774 20 18.4953 20H17.5047C17.214 20 17 19.774 17 19.4953V18.5047C17 18.214 17.226 18 17.5047 18ZM17.5047 12H18.4953C18.786 12 19 12.226 19 12.5047V13.4953C19 13.786 18.774 14 18.4953 14H17.5047C17.214 14 17 13.774 17 13.4953V12.5047C17 12.214 17.226 12 17.5047 12ZM17.5047 9H18.4953C18.786 9 19 9.22596 19 9.50468V10.4953C19 10.786 18.774 11 18.4953 11H17.5047C17.214 11 17 10.774 17 10.4953V9.50468C17 9.21404 17.226 9 17.5047 9Z" fill="#353535" />
                        </svg>
                    </div>
                </div>

                <Modal isOpen={isOpen} onClose={onClose}>
                    <ModalOverlay />
                    <ModalContent className={getDarkModoe.ToggleDarkModeReducer.chekced ? "chageDateContentDark" : "chageDateContentLight"}>
                        <ModalHeader>Запросить изменение даты</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <input type="datetime-local" className='changeDateInput' value={convertStartDate(currentDates)} onChange={(e) => setDndDateConfirm(e.target.value)} style={dateisCurrent(allitemForStatus.alltask[0].endDate) ? { color: "red" } : { border: "#707A99" }} />
                        </ModalBody>

                        <ModalFooter>
                            <Button colorScheme='blue' mr={3} onClick={() => [handleDate(), onClose()]} >Запросить</Button>
                            <Button variant='ghost' onClick={onClose}>
                                Закрыть
                            </Button>

                        </ModalFooter>
                    </ModalContent>
                </Modal>
            </div>
        )
    }

}